import styled, { css, keyframes } from "styled-components";
import { viewSizeCalculator } from "../../../../utils";

export const LegendHexagonLeft = styled.div`
  float: left;
  border-left: ${({ size, color }) =>
    `${viewSizeCalculator(size / 16)} solid ${color}`};
  border-top: ${({ size2 }) =>
    `${viewSizeCalculator(size2 / 16)} solid transparent`};
  border-bottom: ${({ size2 }) =>
    `${viewSizeCalculator(size2 / 16)} solid transparent`};
`;

export const TextWrapper = styled.div`
  color: #333333;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: ${({ labelFontSize }) =>
    `${viewSizeCalculator(0.7369)}`}; //labelFontSize};
  font-style: normal;
  font-weight: 500;
  text-transform: capitalize;
`;

export const LegendHexagonRight = styled.div`
  float: left;
  width: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  height: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  border: none;
  border-radius: ${() => `${viewSizeCalculator(0.2838)}`}; // 0.2838rem
  background-color: ${({ color }) => color || "#ccc"};
  /* border-right: ${({ size, color }) =>
    `${viewSizeCalculator(size / 16)} solid ${color}`};
border-top: ${({ size2 }) =>
    `${viewSizeCalculator(size2 / 16)} solid transparent`};
border-bottom: ${({ size2 }) =>
    `${viewSizeCalculator(size2 / 16)} solid transparent`}; */
`;

export const LegendHexagonBody = styled.div`
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: ${({ size2 }) => `${viewSizeCalculator((size2 * 2) / 16)}`};
  background-color: transparent;
  padding: ${({ isSmallerHex }) =>
    !isSmallerHex
      ? `0px ${viewSizeCalculator(2.25)} 0px ${viewSizeCalculator(1)}`
      : `0px ${viewSizeCalculator(0.3125)}`};

  h2 {
    color: #fff;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: "Inter";
    font-size: ${() => viewSizeCalculator(0.688)}; //0.688rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
    padding-right: ${() => viewSizeCalculator(0.7)}; //0.375rem;
  }

  p {
    color: #606080;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: "Inter";
    font-size: ${() => viewSizeCalculator(0.688)}; //0.688rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
  }
`;

export const LegendMainContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${() => `${viewSizeCalculator(2.25)}`}; // 2.25rem
  flex-wrap: wrap;
`;

// Define the shimmer animation
const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

export const LegendTitle = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.737)}`}; // 0.737rem
  font-weight: 500;
  color: #333333;

  ${({ loading, size }) =>
    loading &&
    css`
      width: ${viewSizeCalculator(5)};
      height: ${viewSizeCalculator(1)};
      background: linear-gradient(90deg, #ededed 25%, #fefefe 50%, #ededed 75%);
      background-size: 200% 100%;
      animation: ${shimmer} 3s infinite linear;
      border-radius: ${viewSizeCalculator(0.2)};
    `}
`;

export const ResetButton = styled.div`
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.875)}`}; //0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  :hover {
    cursor: pointer;
  }
`;

export const ResetButtonWrapper = styled.div`
  display: inline-flex;
  padding: ${() =>
    `${viewSizeCalculator(0.625)} ${viewSizeCalculator(
      0.9375,
    )}`}; //0.625rem 0.9375rem;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem;
  border-radius: ${() => `${viewSizeCalculator(0.3125)}`}; // 0.3125rem;
  opacity: 0.95;
  background: var(--Primary, #242639);
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: ${() => `-${viewSizeCalculator(1)}`};
  :hover {
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div`
  width: ${() => `${viewSizeCalculator(1)}`};
  height: ${() => `${viewSizeCalculator(1)}`};
  svg {
    width: ${() => `${viewSizeCalculator(1)}`};
    height: ${() => `${viewSizeCalculator(1)}`};
  }
  :hover {
    cursor: pointer;
  }
`;

export const LegendMainWraper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${() => `0 ${viewSizeCalculator(0.5)}`};
  position: relative;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
  &:hover {
    cursor: pointer;
  }
`;
export const ValueWrp = styled.div`
  color: #606080;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.6875)}`}; // 0.6875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;
export const LegendInnerWrapper = styled.div`
  position: absolute;
  right: ${() => `${viewSizeCalculator(0.125)}`}; //0.15rem;
  top: ${() => `${viewSizeCalculator(0.1725)}`}; //0.1725rem;
`;

// Hexagon and Grid layout css
export const HexagonContainer = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-items: center;
  grid-area: ${({ row, column }) => `${row} / ${column}`};

  // margin-top: ${({ isSecondColumn, size }) =>
    isSecondColumn ? `-${size / 16}rem` : 0};
  // margin-right: ${({ isSecondRows, size }) =>
    isSecondRows ? `-3.1725000000000003rem` : 0};
  margin-right: ${({ isSecondRows, size }) =>
    isSecondRows ? `-${(size * 0.1269).toFixed(4)}rem` : 0};
`;

export const HexagonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

export const GridWrapper = styled.div`
  width: 100%;
  display: grid;
  place-content: center;
  grid-template-columns: ${({ columns, size }) =>
    `repeat(${columns}, ${size * 1.725}px)`};
  grid-template-rows: ${({ rows, size }) =>
    `repeat(${rows}, ${size * 1.725}px)`};
  grid-column-gap: ${({ size, gap = 0 }) => `${size * 0.25 * gap}px`};
  padding-right: ${() => `${viewSizeCalculator(2.7)}`};
  padding-bottom: ${() => `${viewSizeCalculator(1)}`};
`;

export const MainWrapper = styled.div`
  min-width: ${() => `${viewSizeCalculator(38)}`}; //38rem;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const LegendSection = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${() =>
    `${viewSizeCalculator(0.5)} 0 ${viewSizeCalculator(0.5)}`};
  padding-right: ${() => `${viewSizeCalculator(10, true)}`};
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const StyledSvg = styled.svg`
  /* opacity: ${({ isSvgSelected }) => {
    return isSvgSelected ? 0.4 : 1;
  }}; */
  opacity: 1;
  animation: ${fadeIn} 0.5s ease-in-out;
  transition:
    transform 0.3s linear,
    opacity 0.3s ease-in-out,
    width 0.3s linear,
    height 0.3s linear;

  /* transform: ${({ isSvgSelected, isDefaultState, isLegendSelected }) => {
    return !isSvgSelected
      ? "translate(0.25px, 0) scale(1.06, 1.08)"
      : !isLegendSelected
        ? "translate(0.25px, 0) scale(0.95)"
        : !isDefaultState
          ? "none"
          : "translate(0.25px, 0) scale(0.95)";
  }}; */

  transform: translate(0.25px, 0) scale(1.06, 1.08);

  &:hover {
    cursor: pointer;
    transform: translate(0.25px, 0) scale(1.025, 1.04); // onHover need to confirm intraction
  }
`;

export const HexbinMainContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: ${() => `${viewSizeCalculator(38)}`}; //38rem;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const FilterContainerWrapper = styled.div`
  /* height: ${() => `${viewSizeCalculator(2.1875)}`}; //1.81rem; */
  display: flex;
  align-items: center;
  padding: ${() => `${viewSizeCalculator(2.5)} 0 0 0`};
`;
export const CirularWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerWrapper = styled.div`
  height: 100%;
`;

export const GraphWraperDiv = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: visible;
  padding-bottom: ${() => `${viewSizeCalculator(0.5)}`};
`;

// Type 2 legends

export const LegendType2Wrp = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: ${() => `${viewSizeCalculator(0.25)}`}; //0.25rem;
  &:hover {
    cursor: pointer;
  }
`;

export const CircleIndicatorWrp = styled.div`
  width: ${() => `${viewSizeCalculator(0.625)}`}; //0.625rem;
  height: ${() => `${viewSizeCalculator(0.625)}`}; //0.625rem;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; //1.25rem;
  background: ${({ color }) => color};
`;

export const ValueWrapper = styled.div`
  color: #707c8b;
  leading-trim: both;
  text-edge: cap;
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.6875)}`}; //0.6875rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
`;

export const LegendMainContainerType2 = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${() => `${viewSizeCalculator(0.75)}`}; //0.75rem;
  column-gap: ${() => `${viewSizeCalculator(1)}`}; //1rem;
`;
